<template>
  <div class="h-screen flex justify-center items-center dark:from-gray-900 dark:to-black relative ">
    <div class="w-full">
      <div class="flex justify-center items-center h-full">
        <!-- Login Card -->
        <div class="w-full max-w-md">
            <div class="dark:bg-gray-800 bg-white rounded-lg shadow-lg dark:shadow-gray-900 p-6 relative">
            <!-- Login Method Tabs -->
            <div class="flex mb-6 border-b dark:border-gray-700">
              <button v-for="tab in tabs" :key="tab.value" @click="activeTab = tab.value" :class="[
                'flex-1 py-3 text-center transition-colors duration-200',
                activeTab === tab.value
                  ? 'text-primary border-b-2 border-primary font-medium dark:text-white'
                  : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300',
              ]">
                {{ tab.label }}
              </button>
            </div>

            <div class="login-component-wrapper min-h-[25rem] ">
              <keep-alive>
                <component :is="currentComponent" @onLoginSuccess="handleLoginSuccess" />
              </keep-alive>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import toast from "@/utils/toaster";
// import QRCodeLogin from "@/components/auth/QRCodeLogin.vue";
import PasswordLogin from "@/components/auth/PasswordLogin.vue";
// import SmsLogin from "@/components/auth/SmsLogin.vue";
import { useRouter } from "vue-router";
import { useToken } from "@/hooks/useToken";
const router = useRouter();
const { getToken, setToken, isAuthenticated } = useToken();
import { useAuthStore } from "@/stores/auth";

const authStore = useAuthStore();

const tabs = [
  // { label: "扫码登录", value: "qr", component: QRCodeLogin },
  // { label: "验证码登录", value: "sms", component: SmsLogin },
  { label: "密码登录", value: "password", component: PasswordLogin },
];

const activeTab = ref("password");

const currentComponent = computed(() => {
  const tab = tabs.find((t) => t.value === activeTab.value);
  return tab?.component;
});

const handleLoginSuccess = (token: string, username: string, userRole?: number) => {
  setToken(token);
  toast.success("登录成功");
  authStore.username = username;

  // 存储用户角色信息
  if (userRole !== undefined) {
    authStore.setUserRole(userRole);
  }

  setTimeout(() => {
    router.push("/");
  }, 1000);
};
</script>

<style scoped>
.primary {
  @apply text-blue-600 dark:text-blue-400;
}
</style>
